import { render, staticRenderFns } from "./NotaComercialNoteModal.vue?vue&type=template&id=668e1944"
import script from "./NotaComercialNoteModal.vue?vue&type=script&lang=js"
export * from "./NotaComercialNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports